export const landingLink = 'https://nocoins.today'
